import type { TransactionButtonProps } from '@bitte-ai/types';
import { Button } from '../../ui/button';

const DefaultTxDeclineButton: React.FC<TransactionButtonProps> = ({
  onClick,
  disabled,
  isLoading,
  label,
}) => (
  <Button
    variant="outline"
    className="bitte-w-1/2"
    onClick={onClick}
    disabled={disabled}
  >
    {isLoading ? 'Declining...' : label || 'Decline'}
  </Button>
);

export default DefaultTxDeclineButton;
